/**
 * setReferralToken.js
 * Written by: {{author}}
 */
import { removeStorage, setStorage } from '@minerva-analytics/pantheon';

import getUser from 'store/user/actions/getUser';
import event from 'utils/event';

export const SET_REFERRAL_TOKEN_START = `SET_REFERRAL_TOKEN_START`;
export const SET_REFERRAL_TOKEN_SUCCESS = `SET_REFERRAL_TOKEN_SUCCESS`;
export const SET_REFERRAL_TOKEN_FAILURE = `SET_REFERRAL_TOKEN_FAILURE`;

export const setReferralTokenStart = () => ({
  type: SET_REFERRAL_TOKEN_START,
});

export const setReferralTokenSuccess = (referral) => ({
  type: SET_REFERRAL_TOKEN_SUCCESS,
  referral,
});

export const setReferralTokenFailure = (error) => ({
  type: SET_REFERRAL_TOKEN_FAILURE,
  error,
});

/**
 * 1. Check if this is an anonymous referral
 * 2. If not, set referralToken in session storage and redux
 */
export const setReferralToken = (newReferralUsername) => {
  return async (dispatch) => {
    dispatch(setReferralTokenStart());
    if (newReferralUsername === ``) {
      event(`referral-arrival`, [`referral`, `referral-arrival`, `anonymous`]);
      dispatch(setReferralTokenSuccess(newReferralUsername));
      return null;
    }

    try {
      const referralUser = await dispatch(getUser(newReferralUsername, { referral: true }));
      setStorage({
        key: `referral-token`,
        value: referralUser.username,
        session: true,
      });
      event(`referral-arrival`, [`referral`, `referral-arrival`, `${referralUser.id}`]);
      dispatch(setReferralTokenSuccess(newReferralUsername));
      return newReferralUsername;
    } catch (error) {
      // username of the referral does not exist
      removeStorage({ key: `referral-token` });
      dispatch(setReferralTokenFailure(error));
      return null;
    }
  };
};

export default setReferralToken;
